// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const CC_Filled_Corner0_Rounded = createSinglePathSVG({
  path: 'M21 4.5H3A1.5 1.5 0 0 0 1.5 6v12A1.5 1.5 0 0 0 3 19.5h18a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 21 4.5ZM10.875 15.247a3.75 3.75 0 1 1 0-6.495.75.75 0 1 1-.75 1.299 2.25 2.25 0 1 0 0 3.898.75.75 0 0 1 .75 1.298Zm7.5 0a3.75 3.75 0 1 1 0-6.495.75.75 0 1 1-.75 1.299 2.25 2.25 0 1 0 0 3.898.75.75 0 0 1 .75 1.298Z',
  viewBox: '0 0 24 24',
  glyph: 'CC_Filled_Corner0_Rounded',
})

export const CC_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M21 4.5H3A1.5 1.5 0 0 0 1.5 6v12A1.5 1.5 0 0 0 3 19.5h18a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 21 4.5ZM21 18H3V6h18v12Zm-9.851-3.777a.75.75 0 0 1-.274 1.024 3.75 3.75 0 1 1 0-6.495.75.75 0 1 1-.75 1.299 2.25 2.25 0 1 0 0 3.898.75.75 0 0 1 1.024.274Zm7.5 0a.75.75 0 0 1-.274 1.024 3.75 3.75 0 1 1 0-6.495.75.75 0 1 1-.75 1.299 2.25 2.25 0 1 0 0 3.898.75.75 0 0 1 1.024.274Z',
  viewBox: '0 0 24 24',
  glyph: 'CC_Stroke2_Corner0_Rounded',
})
